import { useContext } from "react";
import { createUseStyles } from "react-jss";
import { EmpdContext } from '../../Context';
import { globe, stethocope } from "../../Assets/Images";
import FiftyFiftySection from "../../Components/FiftyFitySection";
import OneHundredSection from "../../Components/OneHundredSection";
import Hero from "../../Components/Hero";
import { LEADERSHIP_PAGE_CONTENT } from "../../Consts/siteVerbiage";
import useScreenScroll from "../../Hooks/useScreenScroll";
import { RotatingLines } from 'react-loader-spinner';

const useStyles = createUseStyles({
  hero: {
    backgroundPosition: "25% 90% !important",
  },
});

const useMyContext = () => {
    const context = useContext(EmpdContext)
    if( !context ) {
        throw new Error("No provider found for Context")
    }
    return context
}

const Leadership = () => {
  const { isLoading } = useMyContext();

  useScreenScroll();
  const classes = useStyles();

  if( isLoading ) {
  	return (
		<div className='center'>
	        <RotatingLines
    	        strokeColor="#152E54"
        	    strokeWidth="3"
            	animationDuration="1.0"
	            width="48"
    	        visible={true}
        	/>
		</div>
    )
  } else {
    return (
      <div>
        <Hero
          header={LEADERSHIP_PAGE_CONTENT.HERO_TITLE}
          description={LEADERSHIP_PAGE_CONTENT.HERO_DESCRIPTION}
          backgroundImage={stethocope}
          className={classes.hero}
          coverImage={globe}
        />
        <FiftyFiftySection
          id={LEADERSHIP_PAGE_CONTENT.WHO_WE_ARE.ID}
          header={LEADERSHIP_PAGE_CONTENT.WHO_WE_ARE.HEADER}
          left={LEADERSHIP_PAGE_CONTENT.WHO_WE_ARE.LEFT_CONTENT}
          right={LEADERSHIP_PAGE_CONTENT.WHO_WE_ARE.RIGHT_CONTENT}
          variant="grey"
        />
        <OneHundredSection
          id={LEADERSHIP_PAGE_CONTENT.CONTACT.ID}
          header={LEADERSHIP_PAGE_CONTENT.CONTACT.HEADER}
          left={LEADERSHIP_PAGE_CONTENT.CONTACT.LEFT_CONTENT}
          variant="light-grey"
        />
      </div>
    );
  }
};

export default Leadership;
